import { create } from "zustand";

const initialState = {
  upsellProduct: null,
};

export const useUpsellData = create((set, get) => ({
  ...initialState,
  setUpsellProduct: (payload) => set((state) => ({ ...state, upsellProduct: payload })),
}));
